export default "__VITE_PUBLIC_ASSET__de74b636__"